<div class="container py-5 py-sm-7">
    <div class="just justify-content-center">
      <div class="col-md-7 col-lg-5">

        <!-- Card -->
        <div class="card card-lg mb-5">
          <div class="card-body">

            <!-- Form -->
            <form class="js-validate" [formGroup]="userForm">
              <div class="text-center">
                <div class="mb-5">
                  <img class="z-index-2" src="/assets/images/main-logo.png" alt="Image Description" width="250">
                  <h1 class="display-4">Change Password</h1>                 
                </div>
              </div> 

              <!-- Form Group -->
              <!-- <div class="form-group">
                <label class="input-label" for="signinSrEmail">Old Password</label>
                <input type="oldpassword" class="form-control input-login" #oldpassword name="oldpassword" id="signinSroldpassword" tabindex="1" placeholder="8+ characters required" required>
                
            </div> -->

              <div class="form-group">
                <label class="input-label" for="signinSrEmail">New Password</label>
                <input type="password" class="form-control input-login" #password name="password" id="signupSrPassword" placeholder="8+ characters required" minlength="8" maxlength="14"  >
                <div *ngIf="formUser['password'].touched && formUser['password'].invalid" class="alert alert-danger">
                  <div *ngIf="formUser['password'].error['required']">New Password is Required</div>
                 </div>
                 <!-- <div *ngIf="password.touched && password.newIsNotOld">New password can't be the same as current password.</div>-->
              </div>

              <div class="form-group"> 
                <label class="input-label" for="signinSrEmail">Confirm Password</label>
                <input type="password" class="form-control input-login" #cpassword name="cpassword" id="signupSrCPassword" placeholder="8+ characters required" >
                 <div *ngIf="formUser['cpassword'].touched && formUser['cpassword'].invalid" class="alert alert-danger">
                  <div *ngIf="formUser['cpassword'].error['required']">Confirm Password is Required</div>
                 </div>
                 <!--<div *ngIf="formUser['cpassword'].error && formUser['cpassword'].error['confirmedValidator']">New Password and Confirm Password must Match!!</div>-->
                 <div *ngIf="formUser['cpassword'].touched && formUser['cpassword'].errors.newMatchesConfirm">New Password and Confirm Password does not match.</div>
                </div>
              
              <button type="button" (click)="Submit(password.value,cpassword.value)" class="btn btn-login primary form-control">Submit</button>
            
            </form>
            <!-- End Form -->
          </div>

        </div>
        <!-- End Card -->

        <!-- Footer -->
        <div class="text-center">
          <small class="text-cap mb-4">Trusted by Neptune India Ltd</small>
        </div>
        <!-- End Footer -->

      </div>

    </div>
    
  </div>